import Dashboard from "../../dashboard/Dashboard";
import Button from "../../../components/buttons/Button";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowLeftLong,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  EducationResponse,
  IEducation,
  LanguageSpokenResponse,
} from "../types";
import { fetchReviewsByStatus } from "../../../services/review.service";
import showToast from "../../../utils/show.toast";

interface IEducationList {
  isLoading: boolean;
  list: IEducation[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function EducationTable() {
  const navigate = useNavigate();

  const query = useQuery();
  const status = query.get("status");

  const [eduList, setEduList] = useState<IEducationList>({
    isLoading: true,
    list: [],
  });

  const sortedRequests = [...eduList.list].sort((a, b) => a.id - b.id);

  const fetchReviews = async () => {
    try {
      let endpoint: string = "";

      if (status === "pending") {
        endpoint = "teachers/edu-update-unapproved";
      } else if (status === "approved") {
        endpoint = "teachers/edu-update-approved";
      } else if (status === "rejected") {
        endpoint = "teachers/edu-update-reject";
      }

      const response = await fetchReviewsByStatus<EducationResponse>(endpoint);
      console.log(response);

      if (response.status === "success") {
        setEduList({ isLoading: false, list: response.result });
      } else {
        showToast(response.message || "Failed to fetch edu list", false);
      }
    } catch (err: any) {
      showToast(err?.message || "An error occurred", false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <Dashboard pageTitle="Education">
      <div className={style.languagePage}>
        {/* Total Students Count */}
        <div className={style.counterCard}>
          <div className={style.titleTwrapper}>
            <FontAwesomeIcon
              icon={faArrowLeftLong}
              onClick={handleBackClick}
              className={style.backIcon}
            />
            <h2>Education List</h2>
          </div>
        </div>

        {/* Language to Teach Table */}
        <div className={style.pageTable}>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Request Date</th>
              </tr>
            </thead>
            <tbody style={{ cursor: "pointer" }}>
              {sortedRequests.map((request) => (
                <tr
                  key={request.id}
                  onClick={() =>
                    (window.location.href = `/review/education/${request.id}/details`)
                  }
                >
                  <td>{request.id}</td>
                  <td>{request.email}</td>
                  <td>{request.request_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Dashboard>
  );
}
